import { css, Theme } from '@emotion/react'
import { getColorOptions } from 'theme/utils'

export const container = css`
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 268px;
  flex: none;
`

export const containerBlock = (theme: Theme) => css`
  display: flex;
  padding: 14px;
  flex-direction: column;
  align-items: flex-start;
  gap: 14px;
  border-radius: 14px;
  border: 1px solid ${theme.backgrounds.backgroundOne};
  background: ${theme.backgrounds.backgroundFour};
  box-shadow: ${theme.boxShadows.medium};
`

export const title = (theme: Theme) => css`
  font-weight: 600;
  color: ${theme.typographyColors.typographyTwo};
`

export const infoBlock = css`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 10px;
`

export const infoTitle = (theme: Theme) => css`
  font-weight: 600;
  color: ${theme.typographyColors.typographyThree};
`

export const info = (theme: Theme) => css`
  font-weight: 400;
  color: ${theme.typographyColors.typographyThree};
`

export const errorText = (theme: Theme) => css`
  box-sizing: border-box;
  gap: 5px;

  width: fit-content;
  padding: 10px;
  border-radius: 8px;

  font-weight: 700;
  line-height: 22px;
  color: ${theme.colors.red};

  background: ${getColorOptions(theme.colors.red).secondary};
  backdrop-filter: blur(7.5px);
`
